// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/src/components/BooleanIndication/BooleanIndication.less
// module id = 1023
// module chunks = 0